import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";

const STEPS = [
  {
    n: "01",
    title: "File im Portal hochladen",
    desc: "Fahrzeugdaten auslesen und das Originalfile über unser Portal hochladen — einfach die gewünschten Services anklicken und absenden.",
  },
  {
    n: "02",
    title: "Service auswählen",
    desc: "Egal ob du ein Stage 1-3 Tuning benötigst oder du ein individuelles Service (DPF, EGR, Flaps, Vmax, Pops&Bangs...) benötigst. Wir kümmern uns umgehend darum.",
  },
  {
    n: "03",
    title: "Individuelle Optimierung erhalten",
    desc: "Unser Team passt Kennfelder bzw. Zusatzservices präzise an dein Fahrzeug an — geprüft, dokumentiert und sicher. Mit unserer Erfahrung aus 23 Jahren.",
  },
  {
    n: "04",
    title: "Flashen & losfahren",
    desc: "Das optimierte File steht in max. 30 Min. zum Download bereit. Auf das Fahrzeug flashen, testen und die neue Performance erleben.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto-section" data-testid={TID.manifesto.root} className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.35em] text-primary mb-4">Ablauf</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] break-words">
            In drei Schritten{" "}
            <span className="block">zur <span className="text-primary">Optimierung für Ihre Kunden</span></span>
          </h2>
        </div>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="relative grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 group overflow-hidden"
            >
              <div className="md:col-span-4 flex items-center">
                <span className="font-display font-bold text-7xl md:text-8xl lg:text-9xl text-white/10 group-hover:text-primary/25 transition-colors duration-500 leading-none">
                  {s.n}
                </span>
              </div>
              <div className="md:col-span-8 flex flex-col justify-center">
                <h3 className="font-display font-semibold uppercase tracking-tight text-3xl md:text-4xl text-white mb-4">
                  {s.title}
                </h3>
                <p className="max-w-2xl text-base md:text-lg text-white/55 leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
